import React from "react";
import { organisation } from "../../data/clearith";
import ContactForm from "../ContactFrom/ContactForm";

const ContactContent: React.FC = () => (
  <section className="cl-page-section cl-contact-page">
    <div className="container">
      <div className="row g-4 align-items-stretch">
        <div className="col-lg-5">
          <div className="cl-contact-details">
            <span className="cl-kicker">Parlons de votre projet</span>
            <h2 className="cl-section-title">
              Une question sur la formation ou son financement ?
            </h2>
            <p className="cl-lead">
              Décrivez votre objectif et votre situation. CLEARITH pourra vous
              transmettre les informations utiles sur le parcours envisagé.
            </p>
            <div className="cl-contact-item">
              <span>E-mail</span>
              <a href={`mailto:${organisation.email}`}>{organisation.email}</a>
            </div>
            <div className="cl-contact-item">
              <span>Adresse</span>
              <p>{organisation.address}</p>
            </div>
            <div className="cl-contact-item">
              <span>Organisme de formation</span>
              <p>NDA {organisation.activityDeclaration} · Île-de-France</p>
            </div>
          </div>
        </div>
        <div className="col-lg-7">
          <div className="cl-contact-form">
            <div className="cl-contact-form__heading">
              <span className="cl-kicker">Demande d’information</span>
              <h2>Votre projet en quelques lignes.</h2>
            </div>
            <ContactForm />
          </div>
        </div>
      </div>
      <div className="cl-map-wrap">
        <iframe
          src="https://www.google.com/maps?q=40+rue+Madeleine+Michelis,+92200+Neuilly-sur-Seine&output=embed"
          loading="lazy"
          title="Adresse de CLEARITH à Neuilly-sur-Seine"
          referrerPolicy="no-referrer-when-downgrade"
          allowFullScreen
        />
      </div>
    </div>
  </section>
);

export default ContactContent;
